import { useSelector } from 'react-redux';

import { type LicenseFieldProps } from '../components/LicenseField/LicenseFieldController';

import { fieldConfigsSelector, unionOfEditableFieldsSelector } from '../store/selectors';
import { fieldNameConverter } from '../helpers/fieldNameConverter';

// we still allow to configure license field based on feature flag,
// but for now we don't have any need as we control isHidden based on field config instead of feature flag,
// but we keep in case of future use
const useLicenseConfig = ({ configName }: LicenseFieldProps) => {
  const fieldConfigs = useSelector(fieldConfigsSelector);
  const editableFields = useSelector(unionOfEditableFieldsSelector);
  let isDisabled = false;
  let isHidden = false;

  if (configName) {
    const fieldName = fieldNameConverter(configName);

    isDisabled = configName ? !editableFields.has(fieldName) : false;
    isHidden = configName ? fieldConfigs[fieldName]?.hidden === true : false;
  }

  return {
    isDisabled,
    isHidden,
  };
};

export default useLicenseConfig;
